// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__+IFJY","skillsContainer":"Skills_skillsContainer__RZei+","skillsWrapper":"Skills_skillsWrapper__zEwbs"};